

export const displayAndStoreSmartboxWithPreloader = async(data = {}) => {

    const {title, smartboxStorageName, onClose, smartboxId} = data;
    
    const { generateId } = (await import(/* webpackPrefetch: true */ "../../classes/universal_methods/generateId.js"));

    const { displaySmartboxWithPreloader } = (await import(/* webpackPrefetch: true */ "./displaySmartboxWithPreloader.js"));


    // if (window[smartboxStorageName]) {
    //     const theSmartboxId = smartboxId ?? Object.values(window[smartboxStorageName]["smartboxes"])[0]
    // }
   

    const closeAllAssociatedSmartbox = (data)=>{

        if (typeof onClose === "function") onClose(data);

        const {doNotcloseAllOthers} = data;

        if(doNotcloseAllOthers === true) return false;

        if( !(smartboxStorageName in window) ) return false;

        for ( const key in window[smartboxStorageName]["smartboxes"] ) {

            if( !("close" in window[smartboxStorageName]["smartboxes"][key]) ) continue;

            if(typeof  window[smartboxStorageName]["smartboxes"][key].close === "function") window[smartboxStorageName]["smartboxes"][key].close();

        };

        if(smartboxStorageName in window ) delete window[smartboxStorageName];

    };

    const { preloader, smetioSmartbox } = await displaySmartboxWithPreloader({...data, title, onClose:closeAllAssociatedSmartbox, smartboxStorageName });

    const newSmartboxId = generateId();

    if(!window[smartboxStorageName]) window[smartboxStorageName] = { smartboxes: { } };

    window[smartboxStorageName]["smartboxes"][newSmartboxId] = smetioSmartbox;
    window[smartboxStorageName]["idOfcurrentlyVisibleSmartBox"] = newSmartboxId;


    const backBtnIsClicked = () => {
    
        const {idOfcurrentlyVisibleSmartBox} = window[smartboxStorageName];

        if(!(idOfcurrentlyVisibleSmartBox in window[smartboxStorageName]["smartboxes"] )) return false;
    
        window[smartboxStorageName]["smartboxes"][idOfcurrentlyVisibleSmartBox].close({ doNotcloseAllOthers:true });
    
        if(idOfcurrentlyVisibleSmartBox in window[smartboxStorageName]["smartboxes"]) delete window[smartboxStorageName]["smartboxes"][idOfcurrentlyVisibleSmartBox];
    
        const idOfNewCurrentSmartbox = Object.keys(window[smartboxStorageName]["smartboxes"]).pop();
    
        if(!(idOfNewCurrentSmartbox in window[smartboxStorageName]["smartboxes"])) return false;
    
        window[smartboxStorageName]["smartboxes"][idOfNewCurrentSmartbox].show();
        
        window[smartboxStorageName]["idOfcurrentlyVisibleSmartBox"] = idOfNewCurrentSmartbox;
    };



    return { preloader, smetioSmartbox, smartboxId:newSmartboxId, backBtnIsClicked, closeAllAssociatedSmartbox };

};
